/* eslint-disable */
import { produce } from "immer";
import {
  CHAT_TOKEN_START,
  CHAT_TOKEN_SUCCESS,
  CHAT_TOKEN_FAILURE,
} from "../actions/types";

const chatToken = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case CHAT_TOKEN_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case CHAT_TOKEN_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case CHAT_TOKEN_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default chatToken;
